import { useHasWindow } from '@nettbureau/featured-core';
import { ChildrenProps } from '@nettbureau/vibrant-ui';

export function ClientSideRender({ children }: ChildrenProps) {
  const hasWindow = useHasWindow();

  if (!hasWindow) {
    return null;
  }

  return children;
}
